export default [
    {
        id: 1,
        notes: 'Lorem ipsum dolor sit amet, in porro albucius qui, in nec quod novum accumsan, mei ludus tamquam dolores id. No sit debitis meliore postulant, per ex prompta alterum sanctus, pro ne quod dicunt sensibus.',
        job_knowledge: 2,
        productivity: 4,
        teamwork: 4,
        communication_skills: 5,
        total: 15,
        date: 'Nov, 15, 2021',
    },
    {
        id: 2,
        notes: 'Lorem ipsum dolor sit amet, in porro albucius qui, in nec quod novum accumsan, mei ludus tamquam dolores id. No sit debitis meliore postulant, per ex prompta alterum sanctus, pro ne quod dicunt sensibus.',
        job_knowledge: 5,
        productivity: 5,
        teamwork: 15,
        communication_skills: 10,
        total: 35,
        date: 'Nov, 15, 2021',
    },
    {
        id: 3,
        notes: 'Lorem ipsum dolor sit amet, in porro albucius qui, in nec quod novum accumsan, mei ludus tamquam dolores id. No sit debitis meliore postulant, per ex prompta alterum sanctus, pro ne quod dicunt sensibus.',
        job_knowledge: 12,
        productivity: 8,
        teamwork: 20,
        communication_skills: 16,
        total: 56,
        date: 'Dec, 15, 2021',
    },
    {
        id: 4,
        notes: 'Lorem ipsum dolor sit amet, in porro albucius qui, in nec quod novum accumsan, mei ludus tamquam dolores id. No sit debitis meliore postulant, per ex prompta alterum sanctus, pro ne quod dicunt sensibus.',
        job_knowledge: 15,
        productivity: 10,
        teamwork: 20,
        communication_skills: 13,
        total: 58,
        date: 'Feb, 15, 2021',
    },
];
